import(/* webpackMode: "eager" */ "/app/src/components/faqs-page/index.tsx");
import(/* webpackMode: "eager" */ "/app/src/translations/client-setup.ts")